/* eslint-disable react/no-array-index-key */
import React, { useContext } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import Checkbox from '@material-ui/core/Checkbox';
import styled from 'styled-components';
import { TOGGLE_FACE_TO_FACE, DID_EDIT_VISIT } from '../../Context/constants';
import { VisitLogContext } from '../../Context/VisitLogContext';
import { useStyles } from './style';

const FTFdiv = styled.div`
  margin-top: 10px;
`;
export const EditFaceToFace = ({ data }: any) => {
  const { editingRow, dispatch, toggleF2F } = useContext(VisitLogContext);
  const classes = useStyles();

  const visitId = data?.id;
  const editing = editingRow === visitId;
  const ftfLock = data?.lockf2fvisit;
  const showFTF = ftfLock
    ? false
    : data?.isfacetofaceallowed || data?.facetofacevisit;

  const toggleFaceToFace = (props: any) => {
    dispatch({
      type: TOGGLE_FACE_TO_FACE,
      payload: !toggleF2F,
    });
    dispatch({
      type: DID_EDIT_VISIT,
      payload: true,
    });
  };

  let checkedValue: any;

  if (!editing) {
    checkedValue = data.facetofacevisit;
  } else if (editing && data.isfacetofaceallowed) {
    checkedValue = toggleF2F;
  } else {
    checkedValue = data.facetofacevisit;
  }
  return showFTF ? (
    <FTFdiv>
      <FormControlLabel
        control={
          <Checkbox
            checked={checkedValue}
            onChange={toggleFaceToFace}
            disabled={!editing || !data.isfacetofaceallowed}
          />
        }
        label="Face to Face"
        classes={{
          label: classes.label,
        }}
      />
    </FTFdiv>
  ) : (
    <></>
  );
};
